import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sparkles, Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/forgot", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send reset email");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bi-canvas">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-9 h-9 rounded-xl bg-[color:var(--brand-ocean)] flex items-center justify-center"><Sparkles className="w-5 h-5 text-white" /></div>
            <span className="font-display text-lg font-semibold">Eazy Analytics</span>
          </div>
          {sent ? (
            <div data-testid="forgot-sent">
              <div className="w-12 h-12 rounded-2xl bg-[color:rgba(18,132,174,0.15)] flex items-center justify-center mb-4"><MailCheck className="w-6 h-6 text-[color:var(--brand-ocean)]" /></div>
              <h2 className="font-display text-2xl text-[color:var(--ink)]">Check your inbox</h2>
              <p className="text-sm text-[color:var(--ink-3)] mt-2">
                If an account exists for <span className="text-[color:var(--ink)] font-medium">{email}</span>, we've sent a password reset link. It expires in 30 minutes.
              </p>
              <Link to="/login" className="inline-flex items-center gap-1.5 text-[color:var(--brand-ocean)] text-sm font-medium mt-6"><ArrowLeft className="w-4 h-4" />Back to sign in</Link>
            </div>
          ) : (
            <>
              <h2 className="font-display text-2xl text-[color:var(--ink)]">Forgot password?</h2>
              <p className="text-sm text-[color:var(--ink-3)] mt-1">Enter your email and we'll send you a link to reset it.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <Label className="text-[color:var(--ink-2)]">Email</Label>
                  <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-[color:var(--surface)]" required autoFocus />
                </div>
                <Button data-testid="forgot-submit" type="submit" disabled={loading || !email} className="w-full bg-[color:var(--brand-ocean)] hover:bg-[#1E3AD9] text-white">
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
                </Button>
              </form>
              <Link to="/login" className="inline-flex items-center gap-1.5 text-[color:var(--brand-ocean)] text-sm font-medium mt-6"><ArrowLeft className="w-4 h-4" />Back to sign in</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
